import { StylishNewToggleButtonGroup } from '../../../DesignSystems/New/StylishNewToggleButtonGroup';
import React from 'react';
import {
  ALLOWED_FILE_TYPES,
  DATA_SOURCES,
  DATA_SOURCES_LIST,
  DATA_TOGGLE_BUTTONS,
  DataToggleLabels,
  UPLOADED_FILES,
} from '../types';
import { useSitrepSectionWizardContext } from '../SitrepSectionWizardContext';
import { StylishNewCheckbox } from '../../../DesignSystems/New/StylishNewCheckbox';
import { StylishNewButton } from '../../../DesignSystems/New/StylishNewButton';
import UploadedFileBadge from '../common/UploadedFileBadge';
import { CloudUploadOutlined } from '@mui/icons-material';

const DataSources = () => {
  const { selectedDataSources, handleSetSelectedDataSources } =
    useSitrepSectionWizardContext();

  return (
    <div className="data-sources d-flex flex-column gap-4">
      {DATA_SOURCES_LIST.map((source) => (
        <div key={source} className="d-flex flex-row">
          <StylishNewCheckbox
            className="label"
            label={source}
            onClick={(e) => handleSetSelectedDataSources(e, source)}
            checked={selectedDataSources.includes(source)}
          />
        </div>
      ))}
    </div>
  );
};

const UploadedFiles = () => {
  const { uploadedFiles, handleSetUploadedFiles } =
    useSitrepSectionWizardContext();

  return (
    <div className="uploaded-files">
      <p className="text-center">
        Supported file types: {ALLOWED_FILE_TYPES.join(', ')}
      </p>
      <input
        type="file"
        id="uploaded-file-input"
        hidden
        multiple
        onChange={(event) => {
          if (event.target.files) {
            handleSetUploadedFiles(event.target.files);
          }
        }}
        accept={ALLOWED_FILE_TYPES.join(',')}
      />
      <div
        className="bg-white text-center p-5 rounded"
        role="button"
        onClick={() => {
          document.getElementById('uploaded-file-input')?.click();
        }}
      >
        <div className="py-0 py-md-4 mb-3">
          <div className="d-flex justify-content-center mb-1">
            <CloudUploadOutlined className="cloud-upload-icon" />
          </div>
          <p className="weight-600 mb-4 color-black">
            Select a file to upload (max 10)
          </p>
          <StylishNewButton className="button--primary">
            Select File
          </StylishNewButton>
        </div>
      </div>
      {uploadedFiles.length > 0 && (
        <div className="uploaded-files-list mt-3">
          <ul className="list-unstyled">
            {uploadedFiles.map((file, index) => (
              <UploadedFileBadge key={index} file={file} />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const DATA_TOGGLE_BUTTONS_MAP: Record<DataToggleLabels, React.ReactNode> = {
  [DATA_SOURCES]: <DataSources />,
  [UPLOADED_FILES]: <UploadedFiles />,
};

/**
 * This component allows users to select data sources and upload files for AI
 * analysis
 */
const Data = () => {
  const { selectedDataToggleLabel, setSelectedDataToggleLabel } =
    useSitrepSectionWizardContext();

  return (
    <>
      <StylishNewToggleButtonGroup
        data={DATA_TOGGLE_BUTTONS}
        selected={selectedDataToggleLabel}
        onChange={(value) =>
          setSelectedDataToggleLabel(value as DataToggleLabels)
        }
      />
      <div className="content">
        {DATA_TOGGLE_BUTTONS_MAP[selectedDataToggleLabel]}
      </div>
    </>
  );
};

export default Data;
